import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Combobox } from "@headlessui/react";
import {
  ChevronUpDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@heroicons/react/20/solid";
import axios from "axios";
import LoadingAnimation from "../../Components/Loading/LoadingAnimation";
import {
  GET_ALL_DOCUMENT_API,
  DELETE_DOCUMENT_API,
} from "../../Constants/apiRoutes";
import {
  FaEdit,
  FaDownload,
  FaPlus,
  FaTrash,
  FaEye,
  FaFile,
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
} from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoIosSearch } from "react-icons/io";
import { useConfirmation } from "../../Components/ConfirmDialog";
import { ToastContainer } from "react-toastify";
import { PERMISSIONS } from "../../Constants/permissions";
import api from "../../Components/ProtectedRoute/axiosInstance"; 
import Datepicker from "react-tailwindcss-datepicker";
const functionsList = [
  { id: 1, name: "Technical", uuid: "4251-b2d7-b4c4a7aaf8f8" },
  { id: 2, name: "Finance", uuid: "4251-b2d7-b4c4a7bbf7f7" },
  { id: 3, name: "Human Resources", uuid: "4251-b2d7-b4c4a7ccf6f6" },
  { id: 4, name: "Marketing", uuid: "4251-b2d7-b4c4a7ddf5f5" },
  { id: 5, name: "Sales", uuid: "4251-b2d7-b4c4a7eef4f4" },
  { id: 6, name: "Projects", uuid: "4251-b2d7-b4c4a7fff3f3" },
  { id: 7, name: "Legal", uuid: "4251-b2d7-b4c4a7ggf2f2" },
  { id: 8, name: "Management", uuid: "4251-b2d7-b4c4a7ggf9f9" },
  { id: 9, name: "Others", uuid: "4251-b2d7-b4c4a7hhf1f1" },
];

const DocumentsList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [itemsPerPage] = useState(6);
  const [documents, setDocuments] = useState([]);
  const [searchText, setSearchText] = useState("");
  const { showConfirmation, ConfirmationDialog } = useConfirmation();
    const permissionsRaw = localStorage.getItem("PermissionIDs");
    const permissionsID = permissionsRaw
      ? permissionsRaw.split(",").map(Number)
      : [];
const [value, setValue] = useState({
    startDate: "",
    endDate: "",
  });
  const hasDeletePermission = permissionsID?.includes(PERMISSIONS.DELETE_DOCUMENT);
  const fetchDocuments = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const UserID = localStorage.getItem("UserID");

    const params = new URLSearchParams(location.search);
    const filterUUID = params.get("filter");
    const filterParam = params.get("by");
    let departmentId = null;

    if (filterUUID) {
      const selectedFunction = functionsList.find(
        (func) => func.uuid === filterUUID
      );
      departmentId = selectedFunction ? selectedFunction.id : null;
    }

    try {
      const response = await api.get(GET_ALL_DOCUMENT_API, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          ...(departmentId && { DepartmentId: departmentId }),
          UserId: UserID,
          ...(searchText && { searchText: searchText }),
          ...(filterParam && { filter: filterParam }),
             StartDate: value.startDate,
        EndDate: value.endDate,
        },
      });

      if (response.data?.data) {
        setDocuments(response.data.data);
      } else {
        console.warn("No documents found");
        setDocuments([]);
      }
    } catch (error) {
      console.error("Error fetching documents:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      fetchDocuments();
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [location.search, searchText,value.startDate, value.endDate]);
  const handleDelete = (documentId) => {
       if (!hasDeletePermission) {
      toast.error("You do not have permission to delete this user role.");
      return;
    }
    showConfirmation(
      "Delete Document",
      "Are you sure you want to delete this document? This action cannot be undone.",
      async () => {
        const tenantId = localStorage.getItem("TenantID");
        const UserID = localStorage.getItem("UserID");

        try {
          // Perform delete request
          await axios.delete(`${DELETE_DOCUMENT_API}/${documentId}/${UserID}`, {
            data: { tenantId },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });

          // Refresh document list
          fetchDocuments(); // 👈 Refresh document list after deletion
        } catch (error) {
          console.error("Delete failed", error);
        }
      },
      false
    );
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
  };

  const filteredDocuments = documents.filter((doc) => {
    if (!selectedStatus || selectedStatus === "All") return true;
    if (selectedStatus === "Approved") return doc.StatusId === 2;
    if (selectedStatus === "Pending") return doc.StatusId === 1;
    if (selectedStatus === "Rejected")
      return doc.StatusId !== 1 && doc.StatusId !== 2;
    return true;
  });

  const totalItems = filteredDocuments.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = filteredDocuments.slice(startIndex, endIndex);

  const handleAddDocumentClick = () => {
    const params = new URLSearchParams(location.search);
    const filterName = params.get("filter");
    navigate(`/add-document/new?filter=${filterName}`);
  };

  const handleNavigation = (documentId) => {
    const userId = localStorage.getItem("UserID");
    const params = new URLSearchParams(location.search);
    const by = params.get("by");
    const filterName = params.get("filter");
    if (by === "pendingApprovals" && userId) {
      navigate(
        `/documentsDetails/${documentId}/${userId}?filter=${filterName}`
      );
    } else {
      navigate(`/documentsDetails/${documentId}?filter=${filterName}`);
    }
  };

  const handleEdit = (documentId) => {
    const params = new URLSearchParams(location.search);
    const filterName = params.get("filter");

    navigate(`/add-document/${documentId}?filter=${filterName}`, {
      state: { from: location.pathname + location.search },
    });
  };

  const handleDownload = async (filePath) => {
    if (filePath) {
      try {
        const response = await fetch(filePath, {
          mode: "cors",
        });
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute(
          "download",
          filePath.split("/").pop() || "document.pdf"
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        toast.success("Download started");
      } catch (error) {
        console.error("Error downloading file:", error);
        toast.error("Failed to download file");
      }
    } else {
      toast.error("File not found");
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const renderPaginationButtons = () => {
    const buttons = [];
    const maxVisibleButtons = 5;
    let startPage = Math.max(
      1,
      currentPage - Math.floor(maxVisibleButtons / 2)
    );
    let endPage = Math.min(totalPages, startPage + maxVisibleButtons - 1);

    if (endPage - startPage + 1 < maxVisibleButtons) {
      startPage = Math.max(1, endPage - maxVisibleButtons + 1);
    }

    if (startPage > 1) {
      buttons.push(
        <button
          key="1"
          onClick={() => handlePageChange(1)}
          className="relative inline-flex items-center px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
        >
          1
        </button>
      );
      if (startPage > 2) {
        buttons.push(
          <span
            key="ellipsis1"
            className="relative inline-flex items-center px-3 py-2 text-sm text-gray-700"
          >
            ...
          </span>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={`relative inline-flex items-center px-3 py-2 text-sm font-medium ${
            currentPage === i
              ? "z-10 bg-gradient-to-br from-[#8B4513] via-[#A0522D] to-[#D2691E] text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8B4513]"
              : "text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
          }`}
        >
          {i}
        </button>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        buttons.push(
          <span
            key="ellipsis2"
            className="relative inline-flex items-center px-3 py-2 text-sm text-gray-700"
          >
            ...
          </span>
        );
      }
      buttons.push(
        <button
          key={totalPages}
          onClick={() => handlePageChange(totalPages)}
          className="relative inline-flex items-center px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
        >
          {totalPages}
        </button>
      );
    }

    return buttons;
  };

  return (
    <div className="main-container">
      <ConfirmationDialog />
      <ToastContainer />
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6 sm:mb-8">
        <h2 className="heading">Documents</h2>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full sm:w-auto">
          <button
            onClick={handleAddDocumentClick}
            className="flex items-center justify-center px-4 py-2 bg-gradient-to-br from-[#8B4513] via-[#A0522D] to-[#D2691E] text-white rounded-lg hover:from-[#A0522D] hover:to-[#D2691E] transition-all duration-300 w-full sm:w-auto"
          >
            <FaPlus className="mr-2" />
            Add Document
          </button>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row items-center sm:gap-8 lg:gap-32 gap-4 mb-6 sm:mb-8">
        <div className="w-full sm:max-w-xs">
          <Combobox value={selectedStatus} onChange={setSelectedStatus}>
            <div className="relative">
              <Combobox.Input
                className="w-full p-2.5 text-sm border rounded-lg border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#8B4513]/20"
                displayValue={(status) => status || "Filter by Status"}
                placeholder="Filter by Status"
                readOnly
              />
              <Combobox.Button className="absolute inset-y-0 right-0 flex items-center px-3">
                <ChevronUpDownIcon className="h-5 w-5 text-gray-400" />
              </Combobox.Button>
              <Combobox.Options className="absolute z-10 mt-1 w-full bg-white rounded-lg shadow-lg border border-gray-200 py-1 max-h-60 overflow-auto">
                {["All", "Approved", "Pending", "Rejected"].map((status) => (
                  <Combobox.Option
                    key={status}
                    value={status}
                    className={({ active }) =>
                      `cursor-pointer p-2.5 text-sm ${
                        active ? "bg-[#8B4513] text-white" : "text-gray-900"
                      }`
                    }
                  >
                    {status}
                  </Combobox.Option>
                ))}
              </Combobox.Options>
            </div>
          </Combobox>
        </div>

        <div className="relative w-full sm:max-w-xs">
          <input
            type="text"
            placeholder="Search documents..."
            value={searchText}
            onChange={handleSearchChange}
            className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
          />
          <IoIosSearch className="absolute left-3 top-3 text-gray-400" />
        </div>

          <div className="border-solid border-gray-400 border-[1px] rounded-lg w-full sm:max-w-xs">
                              <Datepicker
                                popoverDirection="down"
                                showShortcuts={true}
                                showFooter={true}
                                placeholder="Start Date and End Date"
                                primaryColor={"purple"}
                                value={value}
                                onChange={(newValue) => setValue(newValue)}
                                className="w-full"
                              />
                            </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {currentItems.length > 0 ? (
          currentItems.map((doc) => (
            <div
              key={doc.DocumentID}
              className="bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300"
            >
              <div className="p-4 sm:p-6">
                <div
                  className="flex flex-col sm:flex-row sm:items-start justify-between gap-2 sm:gap-0 mb-4"
                  onClick={() => handleNavigation(doc.DocumentID)}
                >
                  <div className="flex items-start space-x-3 cursor-pointer">
                    {doc.FilePath ? (
                      doc.FilePath.toLowerCase().endsWith(".pdf") ? (
                        <FaFilePdf className="w-5 h-5 text-red-500" />
                      ) : doc.FilePath.toLowerCase().endsWith(".docx") ||
                        doc.FilePath.toLowerCase().endsWith(".doc") ? (
                        <FaFileWord className="w-5 h-5 text-blue-600" />
                      ) : doc.FilePath.toLowerCase().endsWith(".xlsx") ||
                        doc.FilePath.toLowerCase().endsWith(".xls") ? (
                        <FaFileExcel className="w-5 h-5 text-green-600" />
                      ) : (
                        <FaFile className="w-5 h-5 text-gray-500" />
                      )
                    ) : (
                      <FaFile className="w-5 h-5 text-gray-500" />
                    )}
                    <div className="min-w-0 flex-1">
                      <h3 className="font-semibold text-gray-800 line-clamp-1 text-sm sm:text-base">
                        {doc.DocumentName}
                      </h3>
                      <p className="text-xs sm:text-sm text-gray-500 line-clamp-1">
                        {doc.DocumentNo}
                      </p>
                    </div>
                  </div>
                  <span
                    className={`px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                      doc.StatusId === 2
                        ? "bg-green-100 text-green-800"
                        : doc.StatusId === 1
                        ? "bg-yellow-100 text-yellow-800"
                        : doc.StatusId === 3
                        ? "bg-red-100 text-red-800"
                        : doc.StatusId === 4
                        ? "bg-red-100 text-red-800"
                        : "bg-gray-100 text-gray-800"
                    }`}
                  >
                    {doc.StatusId === 2
                      ? "Approved"
                      : doc.StatusId === 1
                      ? "Pending"
                      : doc.StatusId === 3
                      ? "Rejected"
                      : doc.StatusId === 4
                      ? "Declined"
                      : "Unknown"}
                  </span>
                </div>

                <div className="space-y-2 mb-4">
                  <div className="flex justify-between text-xs sm:text-sm">
                    <span className="text-gray-500">Project Type</span>
                    <span className="text-gray-700 font-medium">
                      {doc.ProjectTypeName}
                    </span>
                  </div>
                  <div className="flex justify-between text-xs sm:text-sm">
                    <span className="text-gray-500">Customer</span>
                    <span className="text-gray-700 font-medium">
                      {doc.CustomerName}
                    </span>
                  </div>
                  <div className="flex justify-between text-xs sm:text-sm">
                    <span className="text-gray-500">Upload Date</span>
                    <span className="text-gray-700">
                      {new Date(doc.UpdatedDate).toLocaleDateString()}
                    </span>
                  </div>
                </div>

                <div className="flex justify-end items-center space-x-1 sm:space-x-2 pt-4 border-t border-gray-100">
                  <button
                    onClick={() => handleNavigation(doc.DocumentID)}
                    className="p-1.5 sm:p-2 text-[#8B4513] hover:bg-[#8B4513]/10 rounded-lg transition-colors duration-300"
                    title="View"
                  >
                    <FaEye className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                  </button>
                  <button
                    onClick={() => handleEdit(doc.DocumentID)}
                    className="p-1.5 sm:p-2 text-[#8B4513] hover:bg-[#8B4513]/10 rounded-lg transition-colors duration-300"
                    title="Edit"
                  >
                    <FaEdit className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                  </button>
                  <button
                    onClick={() => handleDownload(doc.FilePath)}
                    className="p-1.5 sm:p-2 text-[#8B4513] hover:bg-[#8B4513]/10 rounded-lg transition-colors duration-300"
                    title="Download"
                  >
                    <FaDownload className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                  </button>
                  <button
                    onClick={() => handleDelete(doc.DocumentID)}
                    className="p-1.5 sm:p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors duration-300"
                    title="Delete"
                  >
                    <FaTrash className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-span-full text-center py-10">
            <p className="text-gray-500">
              {searchText
                ? "No documents match your search"
                : "No documents found"}
            </p>
          </div>
        )}
      </div>

      {totalPages > 1 && (
        <div className="mt-6 sm:mt-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 bg-white px-4 py-3 rounded-lg shadow-sm">
            <div className="text-sm text-gray-700 text-center md:text-left">
              <p className="md:hidden">
                Page {currentPage} of {totalPages}
              </p>
              <p className="hidden md:block">
                Showing <span className="font-medium">{startIndex + 1}</span> to{" "}
                <span className="font-medium">
                  {Math.min(endIndex, totalItems)}
                </span>{" "}
                of <span className="font-medium">{totalItems}</span> results
              </p>
            </div>

            <div className="flex justify-between md:hidden w-full">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`flex items-center px-3 py-1.5 text-sm font-medium rounded-md ${
                  currentPage === 1
                    ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                    : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-300"
                }`}
              >
                <ChevronLeftIcon className="h-4 w-4 mr-1" />
                Previous
              </button>
              <div className="flex items-center space-x-2">
                <span className="text-sm text-gray-700">
                  {currentPage} / {totalPages}
                </span>
              </div>
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`flex items-center px-3 py-1.5 text-sm font-medium rounded-md ${
                  currentPage === totalPages
                    ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                    : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-300"
                }`}
              >
                Next
                <ChevronRightIcon className="h-4 w-4 ml-1" />
              </button>
            </div>

            <div className="hidden md:flex md:flex-1 md:items-center md:justify-end">
              <nav
                className="isolate inline-flex -space-x-px rounded-md shadow-sm"
                aria-label="Pagination"
              >
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className={`relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 ${
                    currentPage === 1
                      ? "cursor-not-allowed"
                      : "hover:text-gray-700"
                  }`}
                >
                  <span className="sr-only">Previous</span>
                  <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
                </button>
                {renderPaginationButtons()}
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className={`relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 ${
                    currentPage === totalPages
                      ? "cursor-not-allowed"
                      : "hover:text-gray-700"
                  }`}
                >
                  <span className="sr-only">Next</span>
                  <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
                </button>
              </nav>
            </div>
          </div>
        </div>
      )}

      {loading && <LoadingAnimation />}
    </div>
  );
};

export default DocumentsList;
